import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/camarero-3-cobrar.webp")